<template>
  <div class="layoutWrap">
    <div class="titleNav">
      <img class="logoImg" src="@/assets/gytb/logo.png" alt="" @click="changeNavTitle(0)" />
      <div class="asideaList">
        <asidea @openLogin="openLogin"></asidea>
      </div>
    </div>
    <div class="layoutMain">
      <router-view :key='$route.fullPath' style="height: 100%;"></router-view>
    </div>
    <div class="footerBox">
      <div class="codeContent">
        <div class="list">
          <div class="title">
            <div class="text">私たちについて</div>
            <div class="xian"></div>
          </div>
          <div class="lista">
            <div class="hint">
              <div class="dian"></div>
              <div class="text">株式会社カラーカラー</div>
            </div>
            <div class="hint">
              <div class="dian"></div>
              <div class="text">812-0004福岡県福岡市博多区榎田2丁目7</div>
            </div>
            <div class="hint">
              <div class="dian"></div>
              <div class="text">E-mail：colorxxcolor@gmail.com</div>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="title">
            <div class="text">Contents</div>
            <div class="xian"></div>
          </div>
          <div class="listb">
            <div class="hint" @click="changeNavTitle(0)">新着商品</div>
            <div class="hint" @click="changeNavTitle(1)">お知らせ</div>
            <div class="hint" @click="changeNavTitle(2)">会社概要</div>
            <div class="hint" @click="changeNavTitle(3)">商品シリーズ一覧</div>
            <div class="hint" @click="changeNavTitle(4)">プライバシーポリシー</div>
            <div class="hint" @click="changeNavTitle(5)">お問い合わせ</div>
          </div>
        </div>
        <div class="list">
          <div class="title">
            <div class="text">最近の投稿</div>
            <div class="xian"></div>
          </div>
          <div class="listc">
            <div class="hint" v-for="(item, index) in informationList" :key='index' @click="newsDetailsBtn(item)">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="code">Copyright © 株式会社ベルハウス All Rights Reserved.</div>
    </div>

    <div class="registerTck" v-if="registerTck">
      <div class="tckContent">
        <img src="@/assets/gytb/registerBj.png" alt="" class="bjImg">
        <img src="@/assets/gytb/delImg.png" alt="" class="delImg" @click="registerTck = false">
        <div class="details">
          <div class="listBox">
            <div class="list">
              <input type="text" placeholder="名前" v-model.trim="formData.name" />
            </div>
            <div class="list">
              <input type="text" placeholder="アカウント" v-model.trim="formData.account" />
            </div>
            <div class="list">
              <input type="text" placeholder="パスワード" v-model.trim="formData.password" />
            </div>
            <div class="list">
              <input type="text" placeholder="招待コード（必須）" v-model.trim="formData.code" />
            </div>
            <div class="list">
              <input type="text" placeholder="郵便（必須）" v-model.trim="formData.email" />
            </div>
          </div>
          <div class="agreementBox" @click="agreementState = !agreementState">
            <img src="@/assets/gytb/noActive.png" alt="" class="img" v-if="!agreementState">
            <img src="@/assets/gytb/yesActive.png" alt="" class="img" v-else>
            <div class="text">個人情報の利用目的<div>について確認した上で同意します。</div>
            </div>
          </div>
          <div class="loginBtn" :class="{ loginBtnYs: agreementState }" @click="loginBtn">ログイン/登録</div>
        </div>
        <div class="errorList" v-if="errorState">
          <img src="@/assets/gytb/hDel.png" alt="" class="img">
          <div class="r">
            <div class="text">{{formData.code?'招待コードエラー':'招待コード未入力'}}</div>
            <div class="texta">招待コードは 店舗イベント/展示会イベント参加時に取得してください。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  eventBus
} from '../utils/eventBus'
import asidea from './components/aside.vue'
export default {
  data() {
    return {
      imgUrl: this.apiList.imgUrl,
      informationList: [],
      registerTck: false,
      agreementState: false,
      formData: {
        name: '',
        account: '',
        password: '',
        code: '',
        email: ''
      },
      errorState: false,
    }
  },
  components: {
    asidea
  },
  created() {
    this.informationListData()
  },
  methods: {
    // 资讯列表
    async informationListData() {
      const url = this.apiList.grUrl + '/news/listts'
      this.$http({
        url: url,
        method: 'post',
        data: this.$http.adornDataa({
          page: 1,
          size: 6,
          groupId: '',
        }, url, true)
      }).then(data => {
        // for (var i = 0; i < 10; i++) {
        //   this.informationList = this.informationList.concat(data.data.records)
        // }
        this.informationList = data.data.records
        console.log(data, '资讯列表');
      })
    },

    // 新闻详情
    newsDetailsBtn(item) {
      this.$router.push({
        path: '/jb/newsDetails',
        query: {
          id: item.id
          /* 你需要的参数 */
        }
      });
    },

    // 跳转类别
    changeNavTitle(index) {
      eventBus.$emit('changeNavTitle', index)
    },

    // 打开注册
    openLogin() {
      this.formData = {
        name: '',
        account: '',
        password: '',
        code: '',
        email: ''
      }
      this.agreementState = false
      this.registerTck = true
    },

    // 注册
    loginBtn() {
      if(!this.agreementState) return 
      if(this.errorState) return
      this.errorState = true
      setTimeout(() => {
        this.errorState = false
      }, 3000);
    },
  }
}
</script>
<style scoped lang="less">
.layoutWrap {
  width: 100%;
  height: 100%;
}

// 顶部标题
.titleNav {
  height: 94px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #E2E2E2;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 0 32px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;

  .logoImg {
    width: 213px;
    height: 64px;
    flex-shrink: 0;
  }

  .asideaList {
    height: 100%;
  }

  justify-content: space-between;
}

.layoutMain {
  width: 100%;
  flex-shrink: 0;
  padding-top: 94px;
}

.footerBox {
  border-top: 1px solid rgba(29, 34, 36, 0.1);
  background-color: #fff;

  .codeContent {
    min-height: 392;
    padding: 78px 216px 0;
    padding-bottom: 48px;
    display: flex;
    justify-content: space-between;

    .list {
      .title {
        width: 400px;
        border-bottom: 1px solid rgba(29, 34, 36, 0.1);
        padding-bottom: 8px;
        position: relative;

        .text {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 20px;
          color: #3D3D3D;
          line-height: 28px;
        }

        .xian {
          width: 120px;
          height: 0px;
          border: 1px solid #0B6BB8;
          position: absolute;
          bottom: -2px;
        }
      }

      .lista {
        padding-top: 24px;
        padding-right: 30px;

        .hint {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          line-height: 22px;

          .dian {
            width: 12px;
            height: 12px;
            background: #1D2224;
            border-radius: 50%;
            margin-right: 6px;
          }

          .text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #3D3D3D;
          }
        }
      }

      .listb,
      .listc {
        padding-right: 30px;

        .hint {
          max-width: 400px;
          min-height: 46px;
          border-radius: 0px 0px 0px 0px;
          padding: 0 12px;
          border-bottom: 1px solid rgba(29, 34, 36, 0.1);
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #1D2224;
          padding: 12px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .code {
    height: 60px;
    background: #0B6BB8;
    border-radius: 0px 0px 0px 0px;
    bottom: 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1D2224;
    text-align: center;
    line-height: 60px;
  }
}

.registerTck {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;

  .tckContent {
    width: 600px;
    height: 603px;
    border-radius: 20px 20px 20px 20px;
    border: 2px solid #FFFFFF;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .bjImg {
      width: 100%;
      height: 100%;
      border-radius: 20px 20px 20px 20px;
      position: absolute;
    }

    .delImg {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 32px;
      top: 59px;
    }

    .errorList {
      width: 400px;
      // height: 94px;
      background: rgba(255, 77, 79, 0.15);
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #FF4D4F;
      position: absolute;
      top: 50%;
      left: 50%;transform: translate(-50%, -50%);
      display: flex;
      padding: 14px;

      .img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }

      .r {
        .text {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #FF4D4F;
          line-height: 22px;padding-top: 4px;margin-bottom: 8px;
        }

        .texta {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #FF4D4F;
          line-height: 20px;
        }
      }
    }

    .details {
      position: absolute;
      top: 112px;
      width: 460px;
      left: 50%;
      transform: translateX(-50%);
    }

    .listBox {
      .list {
        height: 53px;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #F0F1F5;
        margin-bottom: 16px;

        input {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #1D2224;
          line-height: 53px;
          padding: 0 16px;
          width: 100%;

          &::placeholder {
            color: rgba(29, 34, 36, 0.4);
          }
        }
      }
    }

    .agreementBox {
      cursor: pointer;
      align-items: center;
      display: flex;

      .img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }

      .text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: rgba(29, 34, 36, 0.4);
        display: flex;
        align-items: center;
        line-height: 22px;

        div {
          color: #4783E5;
        }
      }
    }

    .loginBtn {
      height: 60px;
      background: #F0F1F5;
      border-radius: 10px 10px 10px 10px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: rgba(29, 34, 36, 0.4);
      margin-top: 18px;
      text-align: center;
      line-height: 60px;

      &.loginBtnYs {
        background: #4783E5;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue